module.exports = __webpack_public_path__ + "img/morpheus.6ee26320.svg";